<template>
  <div class="cv-share-container" v-if="loadingOver" :style="{paddingTop: pageContainerPadding}"
       :class="[{'share-empty': !alreadyLogged, 'is-plugin': isPlugin}, containerClass]">
    <open-app @openLinkApp="openLinkApp" :small-btn="false" v-show="!isWxMini && !isAlipayClient && !isUCClient && !isQuaReClient && loadingOver && !isPlugin && cvSettings.public_visibility" />
    <div class="no-public-cv-prompt-container" v-if="isShowPublicCvPromptToolTips && !isPlugin">
      <div class="no-public-cv-prompt-layout flex-between" >
        <div class="no-public-cv-prompt-content flex-start">
          <i class="iconfont iconx close-no-public-cv-prompt" @click="onCloseCvPromptLayout"/>
          <span style="white-space: nowrap">简历未公开，被分享者将无法查看简历</span>
        </div>
        <button class="theme-button public-cv-setting-btn" @click="toShareManage">简历设置</button>
      </div>
    </div>
    <div class="flex-between tab-container" v-if="!cvNotData && !!authorityData.visibility && !isPlugin" :style="{ top: tabContainerTop }"
        :class="[ alreadyLogged && isWxMini ? 'tab-container-logged-mini' : alreadyLogged ? 'tab-container-logged' : '']">
      <div class="tab-wrapper">
        <div class="tab-list">
          <w-tab :tabList="tabList" :currentTab="currentTab" @changeTab="changeTab"/>
        </div>
      </div>
    </div>
    <div class="share-img" v-if="!alreadyLogged" @click="toLogin">
      <img src="https://files.wondercv.com/cv/share/cv-share.png" alt="">
    </div>
    <w-no-result v-else-if="overdueCv || cvNotData || !authorityData.visibility" :text="noResultText" />
    <template v-else-if="alreadyLogged && !!authorityData.visibility">
      <div v-show="currentTab === 0" class="mobile-cv-container">
        <mobile-cv page-type="share" :authority-data="authorityData" ref="mobileCv" :isPlugin="isPlugin"  @addComment="addComment"
                   @changeCommentListState="changeCommentListState" />
      </div>
      <div class="cv-file-container">
        <div class="cv-dom-wrapper" v-show="currentTab === 1">
          <div class="cv-container">
            <file-cv :show-page-line="false"></file-cv>
          </div>
        </div>
      </div>
    </template>
    <w-share-wx :state="shareWxState" @handleClose="changeShareState"></w-share-wx>
    <div class="flex-between tool-tip-container" v-if="cv && cv.basic_info && cv.basic_info.kind !== 'template' && cv.basic_info.kind !== 'sample'" :class="{'tool-tip-not-owner': !authorityData.owner}" v-show="shareCommentsState && !cvNotData && (alreadyLogged) && !isPlugin && cvSettings.public_visibility">
      <div class="flex-start tool-tip-text">
        <span>👆点击文字，可对段落内容进行点评</span>
      </div>
      <div class="tool-tip-btn" @click="saveShareComment">我知道了</div>
    </div>
    <!-- 如果是插件，不显示 -->
    <template v-if="!isPlugin">
      <div class="page-footer footer flex-between" v-if="!cvNotData && !commentDialogState && authorityData.owner">
        <button class="white-button flex-center" @click="toShareManage">
          <i class="iconfont iconsimidushezhi"/>
          <span>谁看过我</span>
        </button>
        <button class="theme-button flex-center" @click="changeShareDialog">
          <i class="iconfont iconshangchuan"/>
          <span>发送简历</span>
        </button>
      </div>
      <comment-dialog :comment-dialog-state="commentDialogState" @addCommentValue="addCommentValue"
                      @handleClose="changeCommentDialogState"/>
      <comment-list ref="commentList" :comment-list-state="commentListState" :is-comment-state="commentDialogState"
                    @handleClose="changeCommentListState" @changeCommentDialogState="changeCommentDialogState"/>
      <share-dialog :share-dialog-state="shareDialogState"
                    :cv-settings="cvSettings"
                    @handleClose="changeShareDialog"
                    @changeSwitchValue="changeSettingsValue"
                    @contentItemClick="contentItemClick" />
    </template>
  </div>
</template>

<script>
  import FileCv from '../cv-components/file-cv'
  import MobileCv from '../cv-editor/mobile-cv'
  import WTab from '../../components/global/w-tab'
  import WNavBar from '../../components/global/w-navbar'
  import WShareWx from '../../components/global/w-share-wx'
  import CommentDialog from './Components/CommentDialog'
  import CommentList from './Components/CommentList'
  import ShareDialog from './Components/ShareDialog'
  import WNoResult from '../../components/global/w-no-result'
  import OpenApp from '../../components/cv/open-app'
  import {eventMixin, envMixin, loginMixin, windowEventMixin, downloadAPPMixin} from '../../assets/js/mixin/global'
  import {componentsMixin} from "../../assets/js/mixin/components"
  import { userMixin } from '../../assets/js/mixin/user'
  import {cvMixin, cvShareMixin} from '../../assets/js/mixin/cv'
  import {mapState, mapActions, mapMutations} from 'vuex'
  import api from "../../api/api-list/index"
  import Cookies from 'js-cookie'

  export default {
    name: 'cv-share',
    mixins: [
      eventMixin,
      cvMixin,
      envMixin,
      loginMixin,
      componentsMixin,
      windowEventMixin,
      downloadAPPMixin,
      userMixin,
      cvShareMixin
    ],
    data() {
      return {
        loadingOver: false,
        // tabList: [{label: '手机预览', type: 'mobile'}, {label: '文件预览', type: 'doc'},],
        tabList: [{label: '手机预览', type: 'mobile'}],
        currentTab: 0,
        shareWxState: false,
        shareCommentsState: false,
        handleScroll: () => {},
        commentDialogState: false,
        commentListState: false,
        shareDialogState: false,
        cvNotData: false, // 没有简历
        overdueCv: false, // 过期简历
        authorityData: {}, // 当前简历查看者的权限
        cvSettings: {}, // 当前简历的设置状态
        showNotify: false,
        isPlugin: false, //是否是插件
        isShowCvToolTips: true, // 显示公开简历提示条
      }
    },
    beforeRouteLeave(to, from, next) {
      this.$db.ss.remove('shareByPreview')
      next()
    },
    created() {
      this.handleScroll = this.throttle(this.cvShareScroll, 150)
      let { query } = this.$route;
      // 判断是否是插件
      if(query.isPlugin === 'true'){
        this.isPlugin = true
      }
    },
    async mounted() {
      try {
        let { token } = this.$route.params
        if(token.length < 9 && this.isWxMini){
          let res = await api.cvShare.getCvEncodedToken(token, {token: token, from_admin: false})
          if(res.code === 1000) {
            let {encoded_token} = res.data;
            window.location.replace(`/cvs/${encoded_token}/share`)
          }
        }
        this.verifyLogin()
        this.initStoreData()
        this.setAllCommentData([])
        await this.loginByWx()
        this._initLoggedState()
        await this.getAuthorityData()
        this.showMessageNotify()
        this.getCvData()
      } catch (error) {
      }
    },
    computed: {
      ...mapState('cv', ['cv']),
      ...mapState('cvShare', ['allCommentData']),
      tabContainerTop() {
        if (this.isHarmony) {
          return 0
        } else if (this.isWxMini || this.isAlipayClient || this.isUCClient || this.isQuaReClient || !this.cvSettings.public_visibility) {
          return this.isShowPublicCvPromptToolTips ? '42px' : 0
        } else {
          return '56px'
        }
      },
      pageContainerPadding() {
        if (this.isHarmony) {
          return '56px'
        } else if (this.isWxMini || this.isAlipayClient || this.isUCClient || this.isQuaReClient || this.isPlugin || !this.cvSettings.public_visibility) {
          return this.isShowPublicCvPromptToolTips ? '98px' : '56px'
        } else {
          return '112px'
        }
      },
      containerClass() {
        if (this.shareCommentsState) {
          return this.authorityData.owner ? 'share-comments-container' : 'container-not-owner-comment'
        } else {
          return !this.authorityData.owner ? 'container-not-bottom' : ''
        }
      },
      noResultText() {
        if (this.overdueCv) {
          return '简历分享链接已过期，请重新分享查看'
        } else if (!this.authorityData.visibility) {
          return '抱歉，你没有权限查看'
        } else if (this.cvNotData) {
          return '简历不存在'
        }
      },
      isShowPublicCvPromptToolTips() { // true显示，false隐藏
        return !this.cvSettings.public_visibility && this.authorityData.owner && this.isShowCvToolTips
      }
    },
    watch: {
      currentTab: {
        handler(val) {
          if (val === 1) {
            setTimeout(() => {
              this.dealEmpty()
            }, 500)
          }
          window.scrollTo(0, 0)
        },
      }
    },
    components: {
      FileCv,
      MobileCv,
      WNavBar,
      WTab,
      WShareWx,
      CommentDialog,
      CommentList,
      WNoResult,
      ShareDialog,
      OpenApp
    },
    methods: {
      ...mapActions('cv', ['getCvDetail']),
      ...mapActions('cvShare', ['getCommentData']),
      ...mapMutations('cvShare', ['setAllCommentData']),
      verifyLogin() {
        if (!this.alreadyLogged) {
          this.needLogin()
        }
      },
      // 点评引导tooltip
      initShareCommentsState() {
        if (!this.allCommentData.length && (this.authorityData.can_comment || this.authorityData.owner)) {
          this.shareCommentsState = true
        }
      },
      // 底部分享弹窗状态
      changeShareDialog() {
        this.shareDialogState = !this.shareDialogState
      },
      // 打开APP
      openLinkApp(needReload) {
        let link = {
          ios: `https://www.wondercv.${process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com'}/wondercv_app/open_app?type=other&open_type=inbox`,
          android: `android://h5/open?type=inbox`,
        }
        this.openApp(link, needReload)
      },
      _initLoggedState() {
        if (Cookies.get('_t') || Cookies.get('_t_plugin')){
          this.alreadyLogged = true
        }
      },
      // 未登录点击登录
      toLogin(type) {
        if (this.alreadyLogged) {
          if (type === 'email') {
            this.sendCvByEmail()
          } else if (this.isWxMini) {
            this.$wechat.miniProgram.reLaunch({url: `/pages/cvIndex/cvIndex?url=${process.env.VUE_APP_HOST}/cvs`})
          } else {
            window.location.replace('/cvs')
          }
        } else {
          if (type === 'email') {
            this.$db.ls.set('needToMail', true)
          }
          this.needLogin()
        }
        // if (this.isWxMini) {
        // 	const url = this.alreadyLogged ? `/pages/cvIndex/cvIndex?url=${ process.env.VUE_APP_HOST }/cvs` : `/pages/index/index`
        // 	this.$wechat.miniProgram.redirectTo({ url })
        // } else {
        // 	this.alreadyLogged ? this.$router.replace('/cvs') : toLogin(window.location.href)
        // }
        // else if (this.isWechatBrowser) {
        // 	toLogin(window.location.href)
        // }
      },
      // 跳转到谁看过我页面
      toShareManage() {
        let { token } = this.$route.params
        this.$router.push(`/share/${token}/manage`)
      },
      // 关闭未公开简历提示框
      onCloseCvPromptLayout() {
        this.isShowCvToolTips = false;
      },
      // 分享弹窗内容点击事件
      contentItemClick(type) {
        if (type === 'email') {
          this.sendCvByEmail()
        } else {
          this.changeShareDialog()
          this.changeShareState()
        }
      },
      // 更改蒙版的状态
      changeShareState() {
        this.shareWxState = !this.shareWxState
      },
      // 获取简历数据
      async getCvData() {
        try {
          if (this.alreadyLogged) {
            let res = await this.getCvDetailData()
            if (res.code === 80120) {
              this.cvNotData = true
              this.loadingOver = true
            } else if (!!this.$db.ls.get('needToMail')) {
              this.sendCvByEmail()
            } else if (res.code === 1000) {
              if (this.authorityData.can_comment || this.authorityData.owner) {
                await this.getCommentData({ payload: {} })
                this.initShareCommentsState()
              }
              await this._getModuleInfoByApi(true, this.$route.params.token)
              this.updateUserViewed()
              setTimeout(() => {
                this.dealEmpty()
              }, 300)
              this.loadingOver = true
              this.$db.ls.remove('shareByPreview')
            } else {
              this.loadingOver = true
            }
          } else {
            this.loadingOver = true
          }
          this.$route.meta.shareByWx('来自超级简历WonderCV',
                                    { title: this.cv.basic_info ? this.cv.basic_info.cv_name : '未命名超级简历',
                                      imgUrl: 'https://files.wondercv.com/cv-share/new-share-icon.png' })
        } catch (e) {
          this.loadingOver = true
          console.log(e)
        }
      },
      // 判断权限，获取简历详情数据
      async getCvDetailData() {
        let { visibility, owner } = this.authorityData
        let { token } = this.$route.params
        let res = {}
        if (owner) this.getSettingsValue()
        if (typeof visibility === 'number' && !!visibility) {
          res = await this.getCvDetail({ token, share: true })
        }
        return res
      },
      // 页面返回函数
      pageBack() {
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateBack()
        } else {
          this.$router.back()
        }
      },
      // 切换手机预览还是文件预览
      changeTab(item, index) {
        this.currentTab = index
      },
      // 发送到邮箱
      sendCvByEmail() {
        let {token} = this.$route.params
        this.$router.push({
          path: '/cvs/send-email',
          query: {
            token: token.slice(0, token.lastIndexOf('-')),
            cv_name: this.cv.basic_info ? this.cv.basic_info.cv_name : '未命名超级简历',
            hideProfile: this.$route.query.hideProfile
          }
        })
      },
      // 点评提醒状态
      saveShareComment() {
        this.shareCommentsState = false
      },
      // 页面滚动事件
      cvShareScroll() {
        this.$refs.mobileCv.profileCommentShow = false
      },
      // 改变评论弹窗的显示状态
      changeCommentDialogState() {
        this.commentDialogState = !this.commentDialogState
      },
      // 点评弹窗的状态
      addComment(moduleData, infoData) {
        if (this.alreadyLogged) {
          this.changeCommentDialogState()
        } else {
          this.needLogin()
        }
      },
      // 显示点评列表详情
      changeCommentListState() {
        this.commentListState = !this.commentListState
      },
      // 添加简历点评回调
      addCommentValue(res) {
        if (res.code === 1000) {
          this.changeCommentDialogState()
          if (res.firstCommentData) {
            this.$refs.mobileCv.shareCommentInfo = {}
            this.changeCommentListState()
          }
          this.$nextTick(() => {
            if (this.$refs.commentList && this.$refs.commentList.$refs.commentScroll) {
              let scrollContent = document.querySelector('.cube-scroll-content')
              let el = this.$refs.commentList.$refs.commentScroll
              el.scrollTo(0, -scrollContent.clientHeight + window.innerHeight + 5, 300)
            }
          })
        } else {
          this.showToast(res.message)
        }
      },
      // 获取分享权力单人事件
      async getAuthorityData() {
        try {
          if (this.alreadyLogged) {
            let { token } = this.$route.params
            if (token.length < 9) {
              this.overdueCv = true
            } else {
              let res = await this.$api.cvShare.getAuthorityByToken(token, this.cvAccountToken)
              if (res.code === 1000) {
                this.authorityData = res.data
              }
            }
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 更新当前者查看时间和状态
      updateUserViewed() {
        try {
          this.$api.cvShare.updateShareCvViewed(this.$route.params.token)
        } catch (error) {
          console.log(error)
        }
      },
      // 显示按钮小红点
      async showMessageNotify() {
        try {
          if (this.authorityData.owner) {
            let { token } = this.$route.params
            const [timeRes, listRes] = await Promise.all([
              this.$api.cvShare.getOwnerViewListTime(token, this.cvAccountToken),
              this.$api.cvShare.getAuthsByToken(token, { page: 1, size: 1 })
            ])
            if (timeRes.code === 1000 && listRes.code === 1000) {
              const { users } = listRes.data
              const { viewed_at } = timeRes.data
              if (users && users.length) {
                const moment = require('moment')
                const { updated_at } = users[0]
                this.showNotify = moment(updated_at).diff(moment(viewed_at), 'seconds') > 0
              }
            }
          }
        } catch (error) {
          console.log(error)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./index";
</style>
